import React from 'react';
import './style.css';
function Loader(props)
{
    const {image} = props;
    const classes = "customLoadingDiv "+image;
    return (
      <div className="customLoadingState">
        <div className={classes}></div>
      </div>
    );
}

export default Loader;